
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslation } from 'react-i18next';
import { 
  Globe, Mail, MessageSquare, File, Lock, Video, Image, Music, Code, Smartphone, Search, Monitor
} from "lucide-react";

type CategoryType = {
  id: string;
  name: string;
  icon: React.ReactNode;
};

type CategoryFilterProps = {
  categories: CategoryType[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
};

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation('alternativ');
  
  return (
    <div className="w-full overflow-x-auto pb-2 -mx-4 md:mx-0 px-4 md:px-0">
      <Tabs value={activeCategory} onValueChange={onCategoryChange} className="w-full">
        <TabsList className="flex w-max min-w-full justify-start bg-white border rounded-lg p-1 h-auto">
          <TabsTrigger 
            value="all" 
            className="flex items-center gap-2 px-4 py-2 data-[state=active]:bg-frikopplad-cream data-[state=active]:text-frikopplad-navy"
          >
            <span>{isMobile ? t('categories.all').split(' ')[0] : t('categories.all')}</span>
          </TabsTrigger>
          
          {categories.map((category) => (
            <TabsTrigger
              key={category.id}
              value={category.id}
              className="flex items-center gap-2 px-4 py-2 whitespace-nowrap data-[state=active]:bg-frikopplad-cream data-[state=active]:text-frikopplad-navy"
            >
              {category.icon}
              <span>{category.name}</span>
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};

export default CategoryFilter;
